export default "__VITE_ASSET__DHkwMtbg__"